import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { RotationUseService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RotationUseCreateDto,
  RotationUseDto,
  RotationUseExcelDownloadDto,
  RotationUseUpdateDto,
} from '../proxy/planning/dtos/rotation-use';
import { ROTATIONUSE_CONFIG, ROTATIONUSE_FIELDS } from './rotation-use.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-rotation-use',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RotationUseService, ConfirmationService],
  templateUrl: './rotation-use.html',
  styleUrl: './rotation-use.scss',
})
export class RotationUse extends BaseCrudComponent<
  RotationUseDto,
  RotationUseCreateDto,
  RotationUseUpdateDto,
  RotationUseExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(RotationUseService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('RotationUse', ids),
  };
  config = ROTATIONUSE_CONFIG;
  fields = ROTATIONUSE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RotationUseDto): RotationUseUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RotationUse';
  }
}
